/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPlanCoversParams,
  PostPlanCoversBody,
  TrainWithMeModulesMediaDtosResponsesPlanCoverListResponse,
  TrainWithMeModulesMediaDtosResponsesPlanCoverResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPlanCovers = (
    params?: GetPlanCoversParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesMediaDtosResponsesPlanCoverListResponse>(
      {url: `/plan-covers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanCoversQueryKey = (params?: GetPlanCoversParams,) => {
    return [
    `/plan-covers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanCoversQueryOptions = <TData = Awaited<ReturnType<typeof getPlanCovers>>, TError = ErrorType<unknown>>(params?: GetPlanCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanCovers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanCoversQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanCovers>>> = ({ signal }) => getPlanCovers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanCovers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanCoversQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanCovers>>>
export type GetPlanCoversQueryError = ErrorType<unknown>


export function useGetPlanCovers<TData = Awaited<ReturnType<typeof getPlanCovers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPlanCoversParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanCovers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanCovers>>,
          TError,
          Awaited<ReturnType<typeof getPlanCovers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanCovers<TData = Awaited<ReturnType<typeof getPlanCovers>>, TError = ErrorType<unknown>>(
 params?: GetPlanCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanCovers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanCovers>>,
          TError,
          Awaited<ReturnType<typeof getPlanCovers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanCovers<TData = Awaited<ReturnType<typeof getPlanCovers>>, TError = ErrorType<unknown>>(
 params?: GetPlanCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanCovers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanCovers<TData = Awaited<ReturnType<typeof getPlanCovers>>, TError = ErrorType<unknown>>(
 params?: GetPlanCoversParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanCovers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanCoversQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPlanCovers = (
    postPlanCoversBody?: BodyType<PostPlanCoversBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postPlanCoversBody?.file !== undefined) {
 formData.append(`file`, postPlanCoversBody.file);
 }

      return customInstance<TrainWithMeModulesMediaDtosResponsesPlanCoverResponse>(
      {url: `/plan-covers`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostPlanCoversMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanCovers>>, TError,{data?: BodyType<PostPlanCoversBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanCovers>>, TError,{data?: BodyType<PostPlanCoversBody>}, TContext> => {

const mutationKey = ['postPlanCovers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanCovers>>, {data?: BodyType<PostPlanCoversBody>}> = (props) => {
          const {data} = props ?? {};

          return  postPlanCovers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanCoversMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanCovers>>>
    export type PostPlanCoversMutationBody = BodyType<PostPlanCoversBody> | undefined
    export type PostPlanCoversMutationError = ErrorType<unknown>

    export const usePostPlanCovers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanCovers>>, TError,{data?: BodyType<PostPlanCoversBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanCovers>>,
        TError,
        {data?: BodyType<PostPlanCoversBody>},
        TContext
      > => {
      return useMutation(getPostPlanCoversMutationOptions(options), queryClient);
    }
    export const deletePlanCoversId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/plan-covers/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePlanCoversIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlanCoversId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlanCoversId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePlanCoversId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlanCoversId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePlanCoversId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlanCoversIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlanCoversId>>>

    export type DeletePlanCoversIdMutationError = ErrorType<unknown>

    export const useDeletePlanCoversId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlanCoversId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlanCoversId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePlanCoversIdMutationOptions(options), queryClient);
    }
